import { render, staticRenderFns } from "./FullCalendar.vue?vue&type=template&id=dd65f7a0"
import script from "./FullCalendar.vue?vue&type=script&lang=js"
export * from "./FullCalendar.vue?vue&type=script&lang=js"
import style0 from "./FullCalendar.vue?vue&type=style&index=0&id=dd65f7a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports